import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SearchDecryptionEffect } from './search-decryption.effect';
import { searchDecryptionReducer } from './search-decryption.reducer';
import { SEARCH_DECRYPTION_STORE_NAME, SearchDecryptionState } from './search-decryption.state';

/** Token of the SearchDecryption reducer */
export const SEARCH_DECRYPTION_REDUCER_TOKEN = new InjectionToken<ActionReducer<SearchDecryptionState, Action>>(
  'Feature SearchDecryption Reducer'
);

/** Provide default reducer for SearchDecryption store */
export function getDefaultSearchDecryptionReducer() {
  return searchDecryptionReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(SEARCH_DECRYPTION_STORE_NAME, SEARCH_DECRYPTION_REDUCER_TOKEN),
    EffectsModule.forFeature([SearchDecryptionEffect]),
  ],
  providers: [{ provide: SEARCH_DECRYPTION_REDUCER_TOKEN, useFactory: getDefaultSearchDecryptionReducer }],
})
export class SearchDecryptionStoreModule {
  public static forRoot<T extends SearchDecryptionState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<SearchDecryptionStoreModule> {
    return {
      ngModule: SearchDecryptionStoreModule,
      providers: [{ provide: SEARCH_DECRYPTION_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
